import { Inmueble } from './../../models/inmueble.model';
import { UsuarioService } from './../../services/usuario/usuario.service';
import { InmuebleService } from './../../services/inmueble/inmueble.service';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import decode from 'jwt-decode';

declare function inicializarPluginsSidebar();


@Component({
  selector: 'app-inmueblepublico',
  templateUrl: './inmueblepublico.component.html',
  styleUrls: ['./inmueblepublico.component.css']
})
export class InmueblepublicoComponent implements OnInit {
  idInmueble: string;
  inmueble: Inmueble = new Inmueble(null, null, null, null, null, null, null, null, null);
  estaLogueado = false;
  rolUsuario= false

  //timer = null;
  //time = 600;

  constructor( public _inmuebleService: InmuebleService, public toastr: ToastrService, public activatedRoute: ActivatedRoute, public _usuarioService: UsuarioService ) {
    this.logueado()
    activatedRoute.params.subscribe(parametros => {
      this.idInmueble = parametros['idinmueble'];
      this.inmueble.imagen = '';
      //console.log(this.idInmueble);
    });
  }

  ngOnInit(): void {

    inicializarPluginsSidebar();
    this.obtenerInmueble(this.idInmueble);

  }

  obtenerInmueble(id: string){
    //clearTimeout(this.timer);
    //this.timer = setTimeout(() => {
    this._inmuebleService.obtenerInmueblePublico( id )
    .subscribe( inmuebleObtenido => {
      this.inmueble = inmuebleObtenido;
    });
 // }, this.time);
  }

  logueado() {
    const token = localStorage.getItem('token');
    if(token !== null){

      const tokenPayload = decode(token);
      if(tokenPayload.usuario.rol === 'ARRENDATARIO'){

        this.rolUsuario = true;
      }else{
        this.rolUsuario = false;
      }
    }

    if(token === null){

      this.rolUsuario = true;
    }

    if (!token) {
      this.estaLogueado = false;
      this.toastr.error('No estás logueado');
      return this.estaLogueado;
      //this.router.navigate(['/login']);
    } else {
      this.estaLogueado = true;
      return this.estaLogueado;
    }

  }

  regresarPagina(){
    window.history.back();
  }



}
